import * as types from './mutation_types'

export const setLoading = ({ commit }, payload) => {
  commit(types.SET_LOADING, payload)
}

export const setSaving = ({ commit }, payload) => {
  commit(types.SET_SAVING, payload)
}

export const setGenerating = ({ commit }, payload) => {
  commit(types.SET_GENERATING, payload)
}

export const setPending = ({ commit }, payload) => {
  commit(types.SET_PENDING, payload)
}

export const setTypeModule = ({ commit }, payload) => {
  commit(types.SET_TYPE_MODULE, payload)
}

export const setModeInvite = ({ commit }, payload) => {
  commit(types.SET_MODE_INVITE, payload)
}



// WEBPACK FOOTER //
// ./src/store/modules/actionState/actions.js